import {ChartColor} from '@wallaby-ui/document';

/**
 * The HAI charts in these reports always build their data in a fixed order:
 * confirmed HAIs ("YES") first, colonizations ("COL") second. `chartColors` is
 * indexed by that same order to generate the chart series, so the indices below
 * must stay aligned with that ordering.
 */
const HAI_STATE_TO_CHART_INDEX: Record<string, number> = {
  YES: 0,
  COL: 1,
};

/**
 * Restricts the chart legend to the currently selected HAI state so it reflects
 * the filtered selection. For 'ALL' (or any unknown value) the full legend is
 * returned unchanged. Only the legend is filtered — the chart series themselves
 * are still built from the full `chartColors` array.
 */
export const filterLegendByHaiState = (items: ChartColor[], haiState: string): ChartColor[] => {
  const index = HAI_STATE_TO_CHART_INDEX[haiState];
  if (index == null) {
    return items;
  }
  const item = items[index];
  return item == null ? items : [item];
};

/**
 * Companion to {@link filterLegendByHaiState} for the chart *data*. The series are still built from
 * the full `chartColors` array, but the states not matching the selected HAI state are flagged with
 * `hideFromLegend` so they drop out of the downloaded image's legend — keeping it in sync with the
 * filtered on-screen legend. For 'ALL' (or any unknown value) the items are returned unchanged.
 */
export const markChartDataLegendByHaiState = (items: ChartColor[], haiState: string): ChartColor[] => {
  const index = HAI_STATE_TO_CHART_INDEX[haiState];
  if (index == null) {
    return items;
  }
  return items.map((item, i) => (i === index ? item : {...item, hideFromLegend: true}));
};
